import { CSSProperties, ReactNode } from 'react';

type ClipboardStyledProps = Readonly<{
  style: CSSProperties;
  children: ReactNode;
}>;

/**
 * Wrapper component that applies custom styles when content is copied to clipboard.
 * The styles only appear in the copied output, not in the rendered UI.
 */
export const ClipboardStyled = ({ style, children }: ClipboardStyledProps) => {
  return <span data-copy-style={JSON.stringify(style)}>{children}</span>;
};
